import { Button, Tabs, Tab, Box, Typography, List, TextField, InputAdornment } from "@mui/material";
import { useRef, useState, useMemo } from "react";
import { useTranslation, Trans } from "react-i18next";
import { VerticalSplitRounded, InfoRounded, CodeRounded } from "@mui/icons-material";
import { Actions } from "../../Content/Actions";
import { useParams } from "react-router";
import { useGetContentModelItemsQuery } from "../../../../../../../../shell/services/instance";
import { AddRounded, SearchRounded } from "@mui/icons-material";
import noSearchResults from "../../../../../../../../../public/images/noSearchResults.svg";
import { CreateVariantDialog } from "../../../../../../../blocks/components/CreateVariantDialog";
import { BlockVariantCard } from "./BlockVariantCard";
import { CodeSample } from "./CodeSample";
import SearchBox from "../../../../../../../../shell/components/SearchBox";
export const BlockTabs = (props: any) => {
  const {
    t
  } = useTranslation();
  const [value, setValue] = useState(0);
  const {
    modelZUID
  } = useParams<{
    modelZUID: string;
  }>();
  const {
    data,
    isFetching
  } = useGetContentModelItemsQuery({
    modelZUID: modelZUID
  });
  const searchRef = useRef(null);
  const [search, setSearch] = useState("");
  const [createVariantDialogOpen, setCreateVariantDialogOpen] = useState(false);
  const sortedBlocks = useMemo(() => {
    if (!data) return [];
    return data.slice().sort((a, b) => {
      return (a.web.metaTitle ?? "")?.localeCompare(b.web.metaTitle ?? "");
    });
  }, [data]);
  const filteredBlocks = useMemo(() => {
    if (!sortedBlocks) return [];
    const normalizedSearch = search.toLowerCase().trim();
    if (!normalizedSearch) return sortedBlocks;
    return sortedBlocks?.filter?.(item => item.web.metaTitle?.toLowerCase().includes(normalizedSearch));
  }, [sortedBlocks, search]);
  return <>
      <Box display="flex" justifyContent={"space-between"} alignItems={"center"} sx={{
      borderBottom: theme => `2px solid ${theme.palette.border}`
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} sx={{
        position: "relative",
        top: "2px"
      }} data-sentry-element="Tabs" data-sentry-source-file="index.tsx">
          <Tab label={t("content.blockTabVariants")} icon={<VerticalSplitRounded fontSize="small" />} iconPosition="start" data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
          <Tab label={t("content.blockTabInfo")} icon={<InfoRounded fontSize="small" />} iconPosition="start" data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
          <Tab label={t("content.blockTabCode")} icon={<CodeRounded fontSize="small" />} iconPosition="start" data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
        </Tabs>
        <Button size="xsmall" sx={{
        color: "text.disabled",
        lineHeight: "20px",
        "& .MuiButton-startIcon": {
          marginRight: "4px"
        }
      }} onClick={() => {
        setCreateVariantDialogOpen(true);
      }} color="inherit" startIcon={<AddRounded color="action" sx={{
        width: "20px",
        height: "20px"
      }} />} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t("content.blockCreateVariant")}
        </Button>
      </Box>
      {value === 0 && <>
          <SearchBox placeholder={t("content.blockSearchVariants")} value={search} onChange={e => setSearch(e.target.value)} variant="outlined" sx={{
        my: 2,
        width: "100%"
      }} inputRef={searchRef} InputProps={{
        startAdornment: <InputAdornment position="start">
                  <SearchRounded color="action" />
                </InputAdornment>
      }} />
          {!!filteredBlocks.length && <List disablePadding sx={{
        borderRadius: "8px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "border",
        backgroundColor: "common.white",
        height: "calc(100% - 150px)",
        overflowY: "auto"
      }}>
              {filteredBlocks.map(block => <BlockVariantCard key={block.meta.ZUID} block={block} />)}
            </List>}
          {search && !filteredBlocks.length && <Box display="flex" gap={2}>
              <Box component="img" src={noSearchResults} width={120} height={110}></Box>
              <Box>
                <Typography variant="h4" maxWidth={458}>
                  <Trans i18nKey="content.blockSearchNoResultsRich" values={{
              search
            }} components={{
              term: <strong style={{
                wordBreak: "break-all"
              }} />
            }} />
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1} mb={3} maxWidth={458}>
                  {t("content.blockSearchNoResultsHint")}
                </Typography>
                <Button variant="contained" startIcon={<SearchRounded />} onClick={() => searchRef?.current?.focus()}>
                  {t("content.blockSearchAgain")}
                </Button>
              </Box>
            </Box>}
        </>}
      {value === 1 && <Box height="calc(100% - 64px)" sx={{
      overflowY: "auto"
    }}>
          <Actions {...props} site={{}} set={{
        type: props.model?.type
      }} />
        </Box>}
      {value === 2 && <CodeSample />}
      {createVariantDialogOpen && <CreateVariantDialog onClose={() => setCreateVariantDialogOpen(false)} model={props?.model} />}
    </>;
};